import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "../../components/Home/Home";
import LandingPage from "../../components/LandingPage/LandingPage";
import AllProducts from "../AllProducts/AllProducts";
import Collections from "../Collections/Collections";
import NewFeed from "../NewFeed/NewFeed";
import Register from "../Register/Register";
import Login from "../Login/Login";
import OtpVerification from "../OtpVerification/OtpVerification";
import PrivateRoutes from "../PrivateRoutes/PrivateRoutes";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import PasswordReset from "../PasswordReset/PasswordReset";
import ProductDetails from "../ProductDetails/ProductDetails";
import ComingSoon from "../ComingSoon/ComingSoon";
import { Cart } from "../Cart/Cart";
import AddAddress from "../Shipping/Shipping";
import OrderHistory from "../OrderHistory/OrderHistory";
import Profile from "../Profile/Profile";
import Policy from "../Policy/Policy";
import AboutPage from "../About/About";
import ProductGrid from "../NewProducts/NewProducts";
import Sample from "../AllProducts/Sample";
import ShoeDisplay from "../../components/ShoeDisplay/ShoeDisplay";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import CartPage from "../CartPage/CartPage";
import NewOrderTracking from "../OrderHistory/OrderTracking/NewOrderTraking";
import NewuserProfile from "../Profile/Profile";
import ModalPopup from "../Modalpopup/Modalpopup";
import NoData from "../../components/NoData/NoData";
import Loaderdots from "../../components/LoaderDots/Loaderdots";
import Resendotp from "../Login/Resendotp";
import VerifyEmail from "../VerifyEmail/VerifyEmail";
import ShippingPolicy from "../ShippingPolicy/ShippingPolicy";
import PrivacyPolicy from "../ShippingPolicy/PrivacyPolicy";
import TermsConditions from "../ShippingPolicy/TermsConditions";
import SizeGuid from "../SideGuide/SizeGuid";
import Refunds from "../ShippingPolicy/Refunds";
import PaymentStatus from "../paymentstatus/success";

export const AllRoutes = () => {
  const location = useLocation();
  const hideShell = ["/login", "/register"].includes(location.pathname);

  return (
    <div>
      {!hideShell && <NavBar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/LandingPage" element={<LandingPage />} />
        {/* <Route
          path="/home"
          element={
          
          
          }
        /> */}
        <Route
          path="/createproducts"
          element={
            <PrivateRoutes>
              <AllProducts />
            </PrivateRoutes>
          }
        />

        <Route path="/newproduct" element={<ProductGrid />} />
        <Route path="/product/:id" element={<ProductDetails />} />
        <Route
          path="/cart"
          element={
            <PrivateRoutes>
              <Cart />
            </PrivateRoutes>
          }
        />
        <Route
          path="/cartpage"
          element={
            <PrivateRoutes>
              <CartPage />
            </PrivateRoutes>
          }
        />
        <Route
          path="/shipping-address"
          element={
            <PrivateRoutes>
              <AddAddress />
            </PrivateRoutes>
          }
        />

        <Route
          path="/order-history-sree"
          element={
            <PrivateRoutes>
              <OrderHistory />
            </PrivateRoutes>
          }
        />
        <Route
          path="/order-history"
          element={
            <PrivateRoutes>
              <NewOrderTracking />
            </PrivateRoutes>
          }
        />
        

        <Route path="/comiingsoon" element={<ComingSoon />} />

        <Route
          path="/products-collection"
          element={
              <Collections />
          }
        />
        <Route
          path="/new-feed"
          element={
            <PrivateRoutes>
              <NewFeed />
            </PrivateRoutes>
          }
        />
        <Route path="/login" element={<Login />} />

        <Route path="/register" element={<Register />} />

        <Route
          path="/forgot-password"
          element={
            // <PrivateRoutes>
            <ForgotPassword />
            // </PrivateRoutes>
          }
        />

        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/otp-verification" element={<OtpVerification />} />
        <Route path="/resend-otp" element={<Resendotp />} />
        <Route path="/user-profile" element={<Profile />} />
        <Route path="/newuserprofile" element={<NewuserProfile />} />
        {/* <Route path="/sample" element={<Sample />} /> */}
        <Route path="/shoeDisplay" element={<ShoeDisplay />} />

        <Route path="/About" element={<AboutPage />} />

        <Route path="/privacy-policy" element={<Policy />} />

        <Route path="/modal" element={<ModalPopup />} />

        <Route path="/nodata" element={<NoData />} />
        <Route path="/Loaderdots" element={<Loaderdots />} />
        <Route path="/shippingPolicy" element={<ShippingPolicy />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/termsConditions" element={<TermsConditions />} />
        <Route path="/refunds" element={<Refunds />} />
        <Route path="/size-guide" element={<SizeGuid />} />

        <Route path="/payment/status" element={<PaymentStatus />} />
        <Route
          path="/update/user-info/email/:token"
          element={
            // <PrivateRoutes>
              <VerifyEmail />
            // </PrivateRoutes>
          }
        />
      </Routes>
      {!hideShell && <Footer />}
    </div>
  );
};
